import React from "react";

import "./contact.scss";

const ContactUs = () => {
  return (
    <section className="contact-section py-5">
      <div className="container">

        <div className="text-center mb-5">
          <span className="sub-title">Contact Us</span>

          <h2 className="fw-bold">
            Let’s Build Something Amazing Together
          </h2>

          <p className="text-muted mx-auto contact-desc">
            Connect with Genius World Consulting Services (GWCS) for
            innovative IT solutions, software development, cloud services,
            and technology consultancy tailored to your business needs.
          </p>
        </div>

        <div className="row g-4">

          <div className="col-lg-5">
            <div className="contact-info-box h-100">

              <div className="contact-item">
                <div className="icon-box">
                  <i className="bx bx-map"></i>
                </div>

                <div>
                  <h5>Office Address</h5>
                  <p>
                    Genius World Consulting Services <br />
                    Devghar-Gaurapur road, near M.S. college of pharmacy, <br /> At. Devghar, Post Khaniwali, Tal Wada, Dist Palghar, <br /> Maharashtra – 401204, India.
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon-box">
                  <i className="bx bx-phone-call"></i>
                </div>

                <div>
                  <h5>Phone Number</h5>
                  <p>+91 892 870 5476</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon-box">
                  <i className="bx bx-envelope"></i>
                </div>

                <div>
                  <h5>Email Address</h5>
                  <p>global.helpdesk@gwcs.in</p>
                </div>
              </div>

              {/* <div className="contact-item">
                <div className="icon-box">
                  <i className="bx bx-time-five"></i>
                </div>

                <div>
                  <h5>Working Hours</h5>
                  <p>Mon - Sat : 10:00 AM - 7:00 PM</p>
                </div>
              </div> */}

            </div>
          </div>

          <div className="col-lg-7">
            <div className="contact-form-box">

              <h4 className="mb-4 fw-bold">
                Send Us a Message
              </h4>

              <form>
                <div className="row">

                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Name"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Write your message..."
                    ></textarea>
                  </div>

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-danger px-4 py-3 rounded-pill"
                    >
                      Send Message
                    </button>
                  </div>

                </div>
              </form>

            </div>
          </div>

        </div>

        <div className="map-box mt-5">
          <iframe
            title="GWCS Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3759.309655990455!2d73.0492963749524!3d19.571230081737983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be70b772d1137f9%3A0xca749a46119dff46!2sM.S.%20COLLEGE%20OF%20PHARMACY!5e0!3m2!1sen!2sin!4v1778318485278!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
          
        </div>

      </div>
    </section>
  );
};

export default ContactUs;